import React, { useEffect, useState } from 'react'
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import SwtichUnlock from '../../assets/SwitchUnlock.svg'
import SwitchInactive from '../../assets/SwitchInactive.svg'
import Typography from '@mui/material/Typography';
import styles from './index.module.scss'
import { style } from "@mui/system";
import { scaleByRatio } from '../../utils/helper'

const CustomSwitch = ({
  txtSwitchOn = '',
  txtSwitchOff = '',
  iconThumb = SwtichUnlock,
  iconThumbUncheck = SwitchInactive,
  checked,
  disabled,
  switchWidth = '100',
  handleChange,
  btnWidth,
  btnTranslateX,
  isOnOff = false,
  profileVariant = null,
}) => {
  //const [isChecked, setIsChecked] = useState(checked)

  const handleSwitchClicked = () => {
    handleChange(!checked)
  }
  useEffect(() => {
    console.log('CustomSwitch :', checked)
  })
  const isProfileSwitch = Boolean(profileVariant);
  const isFriendStatusSwitch = profileVariant === 'friendStatus';
  const profileColor =
    profileVariant === 'edit' ||
    (profileVariant === 'friendStatus' && !checked)
      ? '#e66433'
      : '#2bb673';
  const profileWidth =
    (isFriendStatusSwitch ? 0.76 : 0.8) * switchWidth;

  return (
    <>
      <div
        className={`${styles.switchRoot} ${
          isProfileSwitch ? styles.profileSwitch : ''
        } ${isFriendStatusSwitch ? styles.friendStatusSwitch : ''}`}
        onClick={(event) => {
          if (!event.target.closest('.MuiSwitch-root')) {
            handleSwitchClicked();
          }
        }}>
        {checked && (
          <Typography
            variant="subtitle2"
            className={styles.labelLeft}
            style={{
              width: isProfileSwitch
                ? '62px'
                : `${scaleByRatio(0.5 * switchWidth)}px`,
              left: isProfileSwitch ? '16px' : `${scaleByRatio(25)}px`,
              lineHeight: isProfileSwitch ? '14px' : `${scaleByRatio(14)}px`,
              marginLeft: isOnOff ? '-12px' : '0',
              textTransform:
                isOnOff || isProfileSwitch ? 'uppercase' : 'none',
              paddingBottom: '2px'
            }}
          >
            {txtSwitchOn}
          </Typography>
        )}
        <Switch
          checked={checked}
          disableRipple
          onChange={(event) => {
            event.stopPropagation();
            handleSwitchClicked();
          }}
          sx={{
            "&.MuiSwitch-root": {
              width: `${
                isProfileSwitch
                  ? profileWidth
                  : btnWidth
                    ? btnWidth * switchWidth
                    : 0.8 * switchWidth
              }px`,
              height: isFriendStatusSwitch ? '26px' : '32px',
              padding: `0px`,
              borderRadius: `${scaleByRatio(48)}px`,
              border: isProfileSwitch
                ? `1.5px solid ${profileColor}`
                : 'none',
            },
            "& .MuiSwitch-switchBase": {
              padding: isProfileSwitch ? '2px' : scaleByRatio(1),
              borderRadius: `48px`,
              "&.Mui-checked": {
                transform: isProfileSwitch
                  ? `translateX(${
                      profileWidth - (isFriendStatusSwitch ? 26 : 32)
                    }px)`
                  : btnTranslateX
                    ? `translateX(${btnTranslateX}px)`
                    : `translateX(${
                        scaleByRatio(0.8 * switchWidth) - scaleByRatio(30)
                      }px)`,
                "&+.MuiSwitch-track": {
                  opacity: 1,
                  border: "none",
                  backgroundColor: isProfileSwitch
                    ? profileColor
                    : "#2BB673",
                },
                "& .MuiSwitch-thumb:before": {
                  backgroundImage: isProfileSwitch
                    ? 'none'
                    : `url(${iconThumb})`,
                  backgroundSize: `${scaleByRatio(30)}px ${scaleByRatio(28)}px`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }
              }
            },
            "& .MuiSwitch-thumb": {
              width: isProfileSwitch
                ? isFriendStatusSwitch
                  ? '22px'
                  : '26px'
                : `${scaleByRatio(14)}px`,
              height: isProfileSwitch
                ? isFriendStatusSwitch
                  ? '22px'
                  : '26px'
                : `${scaleByRatio(14)}px`,
              backgroundColor: isProfileSwitch
                ? checked
                  ? '#fff'
                  : profileVariant === 'edit' ||
                      profileVariant === 'friendStatus'
                    ? '#404040'
                    : profileColor
                : undefined,
              boxShadow: isProfileSwitch ? 'none' : undefined,
              "&:before": {
                content: "''",
                position: "absolute",
                width: "100%",
                height: "100%",
                left: 0,
                top: 0,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundImage: isProfileSwitch
                  ? 'none'
                  : `url(${iconThumbUncheck})`,
                backgroundSize: `${scaleByRatio(30)}px ${scaleByRatio(28)}px`
              }
            },
            "& .MuiSwitch-track": {
              borderRadius: "13px",
              backgroundColor: isProfileSwitch ? 'transparent' : "#BCBEC0",
              opacity: 1,
            }
          }}

        />
        {!checked && (
          <Typography
            variant="subtitle2"
            className={styles.labelRight}
            style={{
              width: isProfileSwitch
                ? '62px'
                : `${scaleByRatio(0.5 * switchWidth)}px`,
              left: isProfileSwitch ? '40px' : `${scaleByRatio(35)}px`,
              fontSize: isProfileSwitch ? '12px' : `${scaleByRatio(12)}px`,
              lineHeight: isProfileSwitch ? '14px' : `${scaleByRatio(14)}px`,
              textTransform:
                isOnOff || isProfileSwitch ? 'uppercase' : 'none',
              paddingBottom: '2px'
            }}

          >
            {txtSwitchOff}
          </Typography>
        )}
      </div>

    </>
  );
}

export default CustomSwitch;
